'use client';

import { RadioCard, RadioGroup, Stack } from '@pie/amber';
import { type PaymentMethodUiType } from './utils';

/** Help text under the Credit card option (verbatim from the mock). */
export const CREDIT_CARD_FEE_COPY = 'A 3% processing fee is applied to each payment.';

export type PaymentMethodTypeSelectorProps = {
  value: PaymentMethodUiType;
  onValueChange: (value: PaymentMethodUiType) => void;
  /** Disabled while a session is being (re)fetched, if the caller wants to lock it. */
  disabled?: boolean;
};

/**
 * The three-option payment method type selector (mock 6798-129169). Bank account
 * is the default; Credit card carries the processing-fee note. The value is a UI
 * type — the shell maps it to the API's card/ach before fetching.
 */
export const PaymentMethodTypeSelector = ({
  value,
  onValueChange,
  disabled,
}: PaymentMethodTypeSelectorProps) => (
  <RadioGroup
    legend="Payment method type"
    name="paymentMethodType"
    value={value}
    onValueChange={(next) => onValueChange(next as PaymentMethodUiType)}
    disabled={disabled}
  >
    {/* TODO(EE-305): replace flex-1 with a Stack grow prop once Amber ships it */}
    <Stack direction={{ base: 'column', sm: 'row' }} gap="sm">
      <RadioCard value="bank" label="Bank account" className="flex-1" />
      <RadioCard value="credit" label="Credit card" className="flex-1">
        {CREDIT_CARD_FEE_COPY}
      </RadioCard>
      <RadioCard value="debit" label="Debit card" className="flex-1" />
    </Stack>
  </RadioGroup>
);
